/**
 * Card names in the reading's prose are the links.
 *
 * The pane already opens a card's detail (meaning + this Mystic's symbolism)
 * when its face is tapped. The words name the same cards — "The reversed Ace
 * of Cups signals…" — so those words open the same detail. This splits prose
 * into segments; a segment with `card` is the index (into the cards handed in)
 * of the card it names, kept in the words' own casing ("the Star" links as
 * written; "a star performer" and "star-crossed" do not).
 */
const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export function linkCardNames (text, cards = []) {
  if (!text) return []
  const names = (cards || [])
    .map((c, i) => ({ i, name: (c && c.name) || '' }))
    .filter((n) => n.name)
    .sort((a, b) => b.name.length - a.name.length)         // longest first
  if (!names.length) return [{ text }]
  // Whole names only, in any case ("the Star" links; "a star performer" and
  // "star-crossed" do not — the article stays part of a name that carries one).
  const alt = names.map((n) => escapeRe(n.name)).join('|')
  const re = new RegExp(`(?<![\\w-])(?:${alt})(?![\\w-])`, 'gi')
  const segs = []
  let last = 0
  for (const m of text.matchAll(re)) {
    const hit = m[0]
    const found = names.find((n) => hit.toLowerCase() === n.name.toLowerCase())
    if (!found) continue
    if (m.index > last) segs.push({ text: text.slice(last, m.index) })
    segs.push({ text: hit, card: found.i })
    last = m.index + hit.length
  }
  if (last < text.length) segs.push({ text: text.slice(last) })
  return segs
}
